import React, { FC, useEffect, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import styles from "../../styles/pages/our-team.module.scss";
import { TeamMember } from "../../interfaces";
import { Tab, Tabs, styled } from "@mui/material";
import { TFunction } from "next-i18next";
import { Skeleton } from "@mui/material";

const MemberList: FC<Props> = ({ members, t, loading }) => {
  const [value, setValue] = useState(0);
  const [shownMembers, setShownMembers] = useState(members);

  const handleChange = (_: any, index: number) => {
    switch (index) {
      case 0:
        // all
        //setShownMembers(members);

        //all except trustees
        const allteam = members?.filter(
          (member) => member.cardType !== "Trustees"
        );
        setShownMembers(allteam);
        break;
      case 1:
        // trustees and trustee leaders
        const trustees = members?.filter((member) =>
          ["Trustees", "Trustee-Leader"].includes(member.cardType)
        );
        setShownMembers(trustees);
        break;
      case 2:
        // teachers
        const teachers = members?.filter(
          (member) => member.cardType === "Teachers"
        );
        setShownMembers(teachers);
        break;
    }
    setValue(index);
  };

  useEffect(() => {
    if (!members.length) return;
    setShownMembers(members.filter((member) => member.cardType !== "Trustees"));
  }, [members]);

  return (
    <>
      <StyledTabs
        classes={{
          root: "root",
          flexContainer: "flexContainer",
          indicator: "indicator",
        }}
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <StyledTab label={t("filter-all")} />
        <StyledTab label={t("filter-trustees")} />
        <StyledTab label={t("filter-teachers")} />
      </StyledTabs>

      <div className={styles.people}>
        {!loading
          ? shownMembers.length
            ? shownMembers.map((member) => (
                <Link
                  href={`/our-team/${member.slug}`}
                  key={member.slug}
                  className={styles.personCard}
                >
                  <div className={styles.thumbnail}>
                    <Image
                      src={
                        member.cardImage ||
                        "/assets/images/class_thumbnail_placeholder.png"
                      }
                      alt={member.slug}
                      width={200}
                      height={200}
                      layout="fixed"
                    />
                  </div>
                  <div className={styles.description}>
                    <p className={styles.name}>{member.cardTitle}</p>
                    <p className={styles.position}>{member.cardSubtitle}</p>
                  </div>
                </Link>
              ))
            : null
          : [...Array(5)]?.map((_, index) => (
              <a
                className={styles.personCard}
                key={"our-team-skeleton" + index}
              >
                <div className={styles.thumbnail}>
                  <Skeleton variant="rectangular" height={200} width={200} />
                </div>
                <div className={styles.description}>
                  <Skeleton variant="text" height={20} width={180} />
                  <Skeleton variant="text" height={16} width={180} />
                </div>
              </a>
            ))}
      </div>
    </>
  );
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
  "&.root": {
    margin: "1rem 0 2rem",
  },
  "& .flexContainer": {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      justifyContent: "center",
    },
  },
  "& .indicator": {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const StyledTab = styled(Tab)(() => ({
  textTransform: "none",
}));

interface Props {
  members: TeamMember[];
  t: TFunction;
  loading: boolean;
}

export default MemberList;
